import {ApiRequestNormalizePayloadOptions, ApiRequestOptions} from "../@type";
import {AuthMode} from "../../auth/@const";
import {RequestType} from "../../data/types";
import Request from '../../../../core/gd/data/request'

export default class ApiRequest {


    static GET(context:any, endpoint:string, payload?:any, options?:ApiRequestOptions) {
        return this._request(context, RequestType.GET, endpoint, payload, options)
    }

    static POST(context:any, endpoint:string, payload:any, options?:ApiRequestOptions) {
        return this._request(context, RequestType.POST, endpoint, payload, options)
    }

    static DELETE(context:any, endpoint:string, payload?:any, options?:ApiRequestOptions) {
        return this._request(context, RequestType.DELETE, endpoint, payload, options)
    }

    static PUT(context:any, endpoint:string, payload:any, options?:ApiRequestOptions) {
        return this._request(context, RequestType.PUT, endpoint, payload, options)
    }

    static UPLOAD(context:any, endpoint:string, payload:any, options?:ApiRequestOptions) {
        return this._request(context, RequestType.UPLOAD, endpoint, payload, options)
    }

    static _request(context:any, type:RequestType, endpoint:string, payload:any, options?:ApiRequestOptions): Request {
        throw Error("Not implemnted #049848dfjjd")
    }


    static _normalizeOptions(options? : ApiRequestOptions): ApiRequestOptions{

        if (!options) options = {};

        return {
            processSessionResponse  : _.get(options, 'processSessionResponse', true),
            autoError               : _.get(options, 'autoError', true),
        }
    }

    static _normalizeUrl(apiUrl:string, endpoint:string):string {

        endpoint = this._normalizeEndpoint(endpoint)

        return apiUrl + endpoint;
    }

    static _normalizeEndpoint(endpoint:string):string {

        if (endpoint.substring(0,1)==='/') endpoint.substr(1);

        return endpoint;
    }

    static _normalizePayload(payload:DictionaryStringAny, options:ApiRequestNormalizePayloadOptions) {

        if (!payload) payload={};

        if (_.get(options,'timezone')) payload.zz = moment().format("ZZ");

        // && gd - sometimes we dont' have gd ie teams widget
        if (_.get(options,'sessionId')) payload.sid = gd.sessionId;
        if (_.get(options,'companyId')) payload.cid = gd.companyId;

        return payload
    }

    static _normalizeHeaders(options={}) {

        const headers : DictionaryStringAny = {}

        if (gd.auth && gd.auth.authMode === AuthMode.AUTH_TOKEN_LOCAL_STORAGE) {
            headers['SessionMode'] = 'token';
            headers['SessionToken'] = gd.auth.authToken;
        }

        headers['gd-cid'] = gd.companyId // add cid (companyId) to header -> from now header is the best way to add to request

        return headers

    }



}
